import axios from './index'

// Telewizyta z wizyty: serwer EHR pośredniczy do toru recepcji medapi (numer z karty pacjenta).
const komunikat = (e) => e?.response?.data?.message || e?.message || 'Błąd połączenia'

export default {
  async zadzwon(patientId) {
    try {
      const { data } = await axios.post('/api/auth/telewizyta/zadzwon', { patientId })
      return data
    } catch (e) {
      throw new Error(komunikat(e))
    }
  },
  async polacz(pokoj, patientId) {
    try {
      const { data } = await axios.post('/api/auth/telewizyta/polacz', { pokoj, patientId }, { timeout: 70000 })
      return data
    } catch (e) {
      throw new Error(komunikat(e))
    }
  },
  async rozlacz(pokoj) {
    try {
      await axios.post('/api/auth/telewizyta/rozlacz', { pokoj })
    } catch (e) {
      // rozłączenie jest sprzątaniem — pokój i tak wygasa sam
    }
  }
}
